import { z } from "zod";

import { pipelineRuleTypeSchema } from "./enums";
import { conditionalSchema } from "./conditional";
import { pipelineActionSchema } from "./pipeline-action";

export const pipelineRuleSchema = z.object({
	ruleId: z.string(),
	name: z.string(),
	description: z.string(),
	notes: z.string().optional(),
	conditional: conditionalSchema.nullish(),
	isEnabled: z.boolean(),
	isValid: z.boolean(),
	executionSources: z.array(z.string()).nullish(),
	actions: z.array(pipelineActionSchema),
	type: pipelineRuleTypeSchema,
});
export type PipelineRule = z.infer<typeof pipelineRuleSchema>;
